/* Farbwahl je Linie auf der Produktseite (im Grid bleibt jede Farbe eine eigene Karte; der Kartenteil
   unten greift nur, falls eine Karte .rf-linie trägt). Daten: <script id="rf-linien-daten"> (snippets/rf-linien-daten.liquid).
   Karte: Tipp wechselt Bild, Farbname, Links und Mix-&-Match-Block; Maus darüber zeigt die Farbe als Vorschau.
   Produktseite: Swatches sind Links auf die Farbe, vorab geladen (siehe vorladen). */
(function () {
  if (window.RFLinien) return;
  window.RFLinien = true;
  var LINIEN = {}, BYH = {}, BEREIT = false, MAX_KARTE = 10;

  function laden() {
    if (BEREIT) return true;
    var el = document.getElementById('rf-linien-daten');
    if (!el) return false;
    var d;
    try { d = JSON.parse(el.textContent); } catch (e) { return false; }
    var pos = {};
    String(d.map || '').split(';').forEach(function (x, i) { var h = x.split('=')[0]; if (h) pos[h] = i; });
    (d.farben || []).sort(function (a, b) { return (pos[a.h] || 0) - (pos[b.h] || 0); }).forEach(function (f) {
      (LINIEN[f.l] = LINIEN[f.l] || []).push(f);
      BYH[f.h] = f;
    });
    BEREIT = true;
    return true;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function fuellen(box) {
    if (box.__rf) return;
    var l = LINIEN[box.getAttribute('data-rf-l')];
    box.__rf = 1;
    if (!l || l.length < 2) { box.hidden = true; return; }
    var cur = box.getAttribute('data-rf-h'), alle = box.hasAttribute('data-rf-alle');
    var idx = 0;
    l.forEach(function (f, i) { if (f.h === cur) idx = i; });
    var html = l.map(function (f, i) {
      var hex = /^#/.test(f.x || '') ? ' · ' + f.x.toUpperCase() : '';
      // Produktseite: echte Links (vorab geladen, siehe vorladen); Karten: Knöpfe
      var tag = alle ? 'a href="' + esc(f.u) + '"' : 'button type="button"';
      return '<' + tag + ' class="rf-sw__b' + (f.a ? '' : ' is-aus') + '"' +
        ' style="--c:' + esc(f.x || '#ddd') + '" data-h="' + esc(f.h) + '"' +
        ' aria-label="' + esc(f.f) + (f.a ? '' : ' (ausverkauft)') + '" title="' + esc(f.f) + hex + (f.a ? '' : ' · ausverkauft') + '"' +
        (alle ? (f.h === cur ? ' aria-current="true"' : '') : ' aria-pressed="' + (f.h === cur) + '"') + '></' + (alle ? 'a' : 'button') + '>';
    }).join('');
    box.innerHTML = html;
    if (!alle) kuerzen(box, idx, l.length);
  }
  // Karte: nur so viele Swatches wie in eine Zeile passen, Rest hinter „+N“ (wie Horizon)
  function kuerzen(box, idx, n) {
    var bs = box.querySelectorAll('.rf-sw__b'), w = box.clientWidth, step = bs[0].offsetWidth;
    var k = w && step ? Math.floor((w - 34) / step) : MAX_KARTE;
    if (w && step && n * step <= w) return;
    k = Math.max(1, Math.min(k, MAX_KARTE));
    var zeigen = 0;
    bs.forEach(function (b, i) {
      var an = i === idx || zeigen < k - (idx >= k ? 1 : 0);
      if (an) zeigen++; else b.classList.add('is-mehr');
    });
    if (n - zeigen > 0) box.insertAdjacentHTML('beforeend', '<button type="button" class="rf-sw__mehr" data-rf-mehr aria-label="Alle ' + n + ' Farben zeigen">+' + (n - zeigen) + '</button>');
  }
  function alleFuellen(wurzel) {
    if (!laden()) return;
    (wurzel || document).querySelectorAll('[data-rf-sw]').forEach(fuellen);
  }

  /* ---------- Karte ---------- */
  function karteZeigen(karte, f) {
    var n = karte.querySelector('[data-rf-farbe]');
    if (n) n.textContent = f.f;
    bildSetzen(karte.querySelector('.product__media--featured-visible img, [data-product-image] img'), f.b, f.f);
    // Hover-Bild des Themes: zweites Foto DIESER Farbe; hat sie keins, bleibt das Hauptbild stehen
    var hov = karte.querySelector('.product__media__hover img');
    if (hov) bildSetzen(hov, f.b2 || f.b, f.f);
    karte.classList.toggle('rf-ohne-hover', !f.b2);
  }
  function bildSetzen(img, src, alt) {
    if (!img || !src || img.getAttribute('data-rf-src') === src) return;
    img.removeAttribute('srcset'); img.removeAttribute('sizes');
    img.setAttribute('data-rf-src', src);
    img.src = src; img.alt = alt;
  }
  function karteWaehlen(karte, b, f) {
    karte.querySelectorAll('.rf-sw__b').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    karteZeigen(karte, f);
    karte.querySelectorAll('a[href]').forEach(function (a) {
      if (!a.closest('.rf-sw') && !a.closest('.mm-karte')) a.setAttribute('href', f.u);
    });
    karte.querySelectorAll('[data-mm-h]').forEach(function (x) { x.setAttribute('data-mm-h', f.h); });
    karte.classList.toggle('rf-ist-aus', !f.a);
    if (window.RFMixMatch && window.RFMixMatch.neuZeichnen) window.RFMixMatch.neuZeichnen();
  }
  function gewaehlt(box) {
    var b = box.querySelector('.rf-sw__b[aria-pressed="true"], .rf-sw__b[aria-current="true"]');
    return b && BYH[b.getAttribute('data-h')];
  }

  /* ---------- Produktseite ----------
     Jede Farbe ist ein eigenes Produkt: der Wechsel ist eine normale Navigation. Damit er sofort da ist,
     lädt der Browser die Zielseite vor – Chrome per Speculation Rules (Maus: beim Darüberfahren, Handy:
     beim Antippen), sonst per prefetch. Die Scrollposition wird mitgenommen. */
  function vorladen() {
    if (!document.querySelector('[data-rf-pfarben]') || document.getElementById('rf-vorladen')) return;
    if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      var sr = document.createElement('script');
      sr.type = 'speculationrules'; sr.id = 'rf-vorladen';
      sr.textContent = JSON.stringify({
        prerender: [{ where: { selector_matches: '[data-rf-pfarben] a.rf-sw__b' }, eagerness: 'moderate' }],
        prefetch: [{ where: { selector_matches: '[data-rf-pfarben] a.rf-sw__b' }, eagerness: 'eager' }]
      });
      document.head.appendChild(sr);
    } else {
      document.addEventListener('pointerover', function (e) {
        var a = e.target.closest && e.target.closest('[data-rf-pfarben] a.rf-sw__b');
        if (!a || a.__pf) return;
        a.__pf = 1;
        var l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
      });
    }
  }
  function scrollMerken() {
    try { sessionStorage.setItem('rf-scroll', JSON.stringify({ y: window.pageYOffset, t: Date.now() })); } catch (e) {}
  }
  function scrollHolen() {
    try {
      var d = JSON.parse(sessionStorage.getItem('rf-scroll') || 'null');
      sessionStorage.removeItem('rf-scroll');
      if (d && Date.now() - d.t < 15000 && document.querySelector('[data-rf-pfarben]')) window.scrollTo(0, d.y);
    } catch (e) {}
  }
  scrollHolen();
  document.addEventListener('prerenderingchange', scrollHolen);

  /* ---------- Ereignisse ---------- */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-rf-mehr]');
    if (m) { e.preventDefault(); e.stopPropagation(); m.closest('.rf-sw').classList.add('is-alle'); m.remove(); return; }
    var b = e.target.closest('.rf-sw__b');
    if (!b) return;
    var f = BYH[b.getAttribute('data-h')];
    var pf = b.closest('[data-rf-pfarben]');
    if (pf) {
      // Link navigiert selbst; nur Rückmeldung sofort zeigen und Scrollposition mitnehmen
      if (b.getAttribute('aria-current') === 'true' || e.metaKey || e.ctrlKey || e.shiftKey) { if (b.getAttribute('aria-current') === 'true') e.preventDefault(); return; }
      pf.querySelectorAll('.rf-sw__b').forEach(function (x) { if (x === b) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
      var n = pf.querySelector('[data-rf-farbe]');
      if (n && f) n.textContent = f.f;
      scrollMerken();
      return;
    }
    e.preventDefault(); e.stopPropagation();
    if (!f || b.getAttribute('aria-pressed') === 'true') return;
    var karte = b.closest('.rf-linie');
    if (karte) karteWaehlen(karte, b, f);
  }, true);
  // Maus: Farbe als Vorschau (Bild und Name), beim Verlassen zurück zur gewählten
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || !e.target.closest) return;
    var b = e.target.closest('.rf-sw__b');
    if (!b) return;
    var f = BYH[b.getAttribute('data-h')];
    if (!f) return;
    if (!b.__vor && f.b) { b.__vor = 1; (new Image()).src = f.b; }
    var karte = b.closest('.rf-linie');
    if (karte) karteZeigen(karte, f);
    var pf = b.closest('[data-rf-pfarben]');
    if (pf) { var n = pf.querySelector('[data-rf-farbe]'); if (n) n.textContent = f.f; }
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse' || !e.target.closest) return;
    var box = e.target.closest('[data-rf-sw]');
    if (!box || (e.relatedTarget && box.contains(e.relatedTarget))) return;
    var f = gewaehlt(box);
    if (!f) return;
    var karte = box.closest('.rf-linie');
    if (karte) karteZeigen(karte, f);
    var pf = box.closest('[data-rf-pfarben]');
    if (pf) { var n = pf.querySelector('[data-rf-farbe]'); if (n) n.textContent = f.f; }
  });

  // Start und nachgeladene Grids (Suche, Karussells, Schnellansicht)
  function start() {
    alleFuellen();
    vorladen();
    var wartet = false;
    new MutationObserver(function () {
      if (wartet) return;
      wartet = true;
      requestAnimationFrame(function () { wartet = false; alleFuellen(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
